import React, { useContext, useEffect, useState } from "react";
import { FaRegCalendarAlt, FaRegClock, FaSun, FaMoon } from "react-icons/fa";
import { numero_table } from "../../../ApiServices/Horoscope/BirthDetailsApi";
import { GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import Breadcrumbs from "../../Breadcrumb";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import astroBackgroundImg from '../../../assets/images/Horoscope/horoscopeBackgroundImg.png'
import dayjs from "dayjs";
import { LoaderContext } from "../../../AuthContext/AuthContext";
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import NumerologyImage from "../../../assets/images/new/services1 (3).jpg";
import Prediction from "../../../assets/images/new/services1 (3).jpg";
import { useLocation, useNavigate } from "react-router-dom";
const Numerology = () => {
  const { setLoader, pujaStatus } = useContext(LoaderContext);
  const navigate = useNavigate()
  const location = useLocation()
  const [numeroLogyList, setNumeroLogyList] = useState({
    name: null,
    dob: null,
    destinyNumber: null, radicalNumber: null, nameNumber: null, evilNumber: null, favNumber: null, favDay: null, favGod: null, favMantra: null,
    favColor: null, favMetal: null, favStone: null, favSubStone: null, friendlyNumber: null, neutralNumber: null, radicalRular: null
  });
  const categories = [
    {
      title: "Astrology",
      image: Astro,
      icon: astrology,
      text: "Book Astrology for your spiritual rituals and ceremonies.",
      color: "#ffa415",
      route: "/basic-details",
    },
    {
      title: "Panchang",
      image: Panchang,
      icon: panchang,
      text: "Get a Panchang for your up and down ",
      color: "#fc5528",
      route: "/daily-panchang",
    },
    {
      title: "Numerology",
      image: NumerologyImage,
      icon: numerology,
      text: "Numerology for better life",
      color: "#8139e7",
      route: "/numerology",
    },
    {
      title: "Zodiac Signs",
      image: Prediction,
      icon: zodiacSign,
      text: "Know about Prediction",
      color: "#399be7",
      route: "/Prediction ",
    }

  ];
  useEffect(() => {
    GetUserModelData();
  }, []);
  const GetUserModelData = async () => {
    setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    try {
      const response = await GetUserModel(userID);
      if (response?.ResponseCode == 0) {
        setLoader(false);
        const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item

        const dob = new Date(ModelData[0]?.DOB);

        const year = dob.getFullYear();
        const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
        const day = dob.getDate();

        const [hours, minutes] = ModelData[0]?.BIRTH_TIME.split(":");
        const apiParam = {
          day: day,
          month: month,
          year: year,
          name: ModelData[0]?.FULL_NAME,
        };

        await GetNumberDetails(apiParam, dayjs(dob).format('DD/MM/YYYY'));
      } else {
        setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };
  const GetNumberDetails = async (apiParam, DATE) => {
    setLoader(true);
    try {
      const response = await numero_table(apiParam);
      if (response !== null && response !== undefined) {
        setLoader(false);
        console.log('DATE', DATE)
        setNumeroLogyList((prev) => ({
          ...prev,
          name: response?.name,
          date: DATE,
          destinyNumber: response?.destiny_number,
          radicalNumber: response?.radical_number,
          nameNumber: response?.name_number,
          evilNumber: response?.evil_num,
          favColor: response?.fav_color,
          favDay: response?.fav_day,
          favGod: response?.fav_god,
          favMantra: response?.fav_mantra,
          favMetal: response?.fav_metal,
          favStone: response?.fav_stone,
          favSubStone: response?.fav_substone,
          friendlyNumber: response?.friendly_num,
          neutralNumber: response?.neutral_num,

          radicalRular: response?.radical_ruler,
        }));
      } else {
        setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };
  return (
    <>
      <section className="page-header" style={{ paddingBottom: '30px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">Numerology</h2>
          <div >
            <Breadcrumbs />
          </div>
        </div>
      </section>

      <div className="container pt-4">
        {/* Mobile horizontal scroll */}
        <div className="d-flex d-md-none overflow-auto px-2">
          {categories.map((category, index) => (
            <div
              key={index}
              className="text-center me-3 flex-shrink-0"
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>

        {/* Desktop grid layout */}
        <div className="row justify-content-center text-center g-4 d-none d-md-flex">
          {categories.map((category, index) => (
            <div
              key={index}
              className="col-6 col-sm-4 col-md-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="container-fluid mt-2 p-0">
        <div className="row " style={{ justifyContent: 'center' }}>
          <div className="col-md-10 p-2" >
            <div className=" p-1 glass-card">
              <h5 className="text-center  horoscopeHeaderFont text-uppercase mb-4">Numerology Details</h5>
              <div className="table-responsive">
                <table className="table table-sm">
                  <tbody>
                    {/* Row 1 */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont">Name</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.name}</td>

                      <td className="ps-4 horoscopeFont d-none d-md-table-cell">DOB</td>
                      <td className="d-none d-md-table-cell">:</td>
                      <td className="text-start horoscopeFont d-none d-md-table-cell">{numeroLogyList?.date}</td>
                    </tr>
                    <tr className="d-block d-md-none">
                      <td className="horoscopeFont">DOB</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.date}</td>
                    </tr>

                    {/* Row 2 */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont">Destiny Number</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.destinyNumber}</td>

                      <td className="ps-4 horoscopeFont d-none d-md-table-cell">Radical Number</td>
                      <td className="d-none d-md-table-cell">:</td>
                      <td className="text-start horoscopeFont d-none d-md-table-cell">{numeroLogyList?.radicalNumber}</td>
                    </tr>
                    <tr className="d-block d-md-none">
                      <td className="horoscopeFont">Radical Number</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.radicalNumber}</td>
                    </tr>

                    {/* Row 3 */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont">Name Number</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.nameNumber}</td>

                      <td className="ps-4 horoscopeFont d-none d-md-table-cell">Favorite Color</td>
                      <td className="d-none d-md-table-cell">:</td>
                      <td className="text-start horoscopeFont d-none d-md-table-cell">{numeroLogyList?.favColor}</td>
                    </tr>
                    <tr className="d-block d-md-none">
                      <td className="horoscopeFont">Favorite Color</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.favColor}</td>
                    </tr>

                    {/* Row 4 */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont">Favorite Day</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.favDay}</td>

                      <td className="ps-4 horoscopeFont d-none d-md-table-cell">Favorite God</td>
                      <td className="d-none d-md-table-cell">:</td>
                      <td className="text-start horoscopeFont d-none d-md-table-cell">{numeroLogyList?.favGod}</td>
                    </tr>
                    <tr className="d-block d-md-none">
                      <td className="horoscopeFont">Favorite God</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.favGod}</td>
                    </tr>

                    {/* Row 5 */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont">Favorite Mantra</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.favMantra}</td>

                      <td className="ps-4 horoscopeFont d-none d-md-table-cell">Favorite Metal</td>
                      <td className="d-none d-md-table-cell">:</td>
                      <td className="text-start horoscopeFont d-none d-md-table-cell">{numeroLogyList?.favMetal}</td>
                    </tr>
                    <tr className="d-block d-md-none">
                      <td className="horoscopeFont">Favorite Metal</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.favMetal}</td>
                    </tr>

                    {/* Row 6 */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont">Favorite Stone</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.favStone}</td>

                      <td className="ps-4 horoscopeFont d-none d-md-table-cell">Favorite Substone</td>
                      <td className="d-none d-md-table-cell">:</td>
                      <td className="text-start horoscopeFont d-none d-md-table-cell">{numeroLogyList?.favSubStone}</td>
                    </tr>
                    <tr className="d-block d-md-none">
                      <td className="horoscopeFont">Favorite Substone</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.favSubStone}</td>
                    </tr>

                    {/* Row 7 */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont">Friendly Number</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.friendlyNumber}</td>

                      <td className="ps-4 horoscopeFont d-none d-md-table-cell">Neutral Number</td>
                      <td className="d-none d-md-table-cell">:</td>
                      <td className="text-start horoscopeFont d-none d-md-table-cell">{numeroLogyList?.neutralNumber}</td>
                    </tr>
                    <tr className="d-block d-md-none">
                      <td className="horoscopeFont">Neutral Number</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.neutralNumber}</td>
                    </tr>

                    {/* Final Row - Radical Rular only */}
                    <tr className="d-block d-md-table-row">
                      <td className="horoscopeFont ">Radical Rular</td>
                      <td>:</td>
                      <td className="text-start horoscopeFont">{numeroLogyList?.radicalRular}</td>
                    </tr>
                  </tbody>
                </table>

              </div>

            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Numerology;
